<template>
  <div class="node">
    <van-cell is-link @click="showPopup">
      展示弹出层
    </van-cell>
    <!-- <van-popup v-model="show">内容</van-popup> -->
    <van-field v-model="message" rows="2" autosize label="留言" type="textarea" maxlength="50" placeholder="请输入留言"
      show-word-limit />
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      visible: false,
      message: ''
    }
  },
  methods: {
    showPopup() {
      //   this.show = true
      this.visible = true
    }
  }
}
</script>
<style scoped>

</style>
